<template>
  <button
      class="mx-auto w-full flex flex-col bg-brand-dark-gray rounded-xl px-4 py-3.5 pt-3 pr-2   font-medium text-lg text-white transition-all">
    <div class="flex flex-col m-auto w-full pt-0.5">

      <div class="uppercase text-left w-full text-xs text-brand-light-gray" v-if="inlineLabel">{{ inlineLabel }}</div>

      <div class="flex w-full justify-between my-auto ">
        <div class="flex space-x-2">
          <slot name="start"></slot>
          <div>{{ name }}</div>
        </div>
        <slot name="end">
          <svg class="my-auto" width="24" height="24" viewBox="0 0 24 24" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M10 16.5L14 12L10 7.5" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </slot>
      </div>


    </div>
    <div v-if="$slots.bottom" class="flex flex-wrap">
      <slot name="bottom">

      </slot>
    </div>
  </button>
</template>
<script setup lang="ts">

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  inlineLabel: {
    type: String,
    required: false
  }
})

</script>
